import { createContext } from 'react';

const ObjectsContext = createContext();
export default ObjectsContext;
